import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import cssStyles from "./bg-hamburger.scss?inline"

@customElement('bg-hamburger')
export class BgHamburger extends LitElement {
  @property({ type: Boolean }) active = false;
  @property({ type: String, attribute: 'aria-controls' }) ariaControls = '';
  @property({ type: String, attribute: 'aria-label' }) ariaLabel = 'Toggle menu';

  static styles = [
    unsafeCSS(cssStyles)
  ]

  close() {
    this.active = false;
    this.setAttribute('aria-expanded', 'false');
  }

  private _handleClick(e: Event) {
    e.stopPropagation();
    this.active = !this.active;
    this.setAttribute('aria-expanded', this.active.toString());
    
    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('bg-hamburger-toggle', {
      bubbles: true,
      composed: true,
      detail: {
        active: this.active,
        targetId: this.ariaControls
      }
    }));
  }

  private _handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this._handleClick(e);
    }
  }

  render() {
    return html`
      <button 
        class="hamburger ${this.active ? 'active' : ''}" 
        part="hamburger"
        @click=${this._handleClick}
        @keydown=${this._handleKeydown}
        aria-controls=${this.ariaControls}
        aria-label=${this.ariaLabel}
        aria-expanded=${this.active}
        role="button"
        tabindex="0"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'bg-hamburger': BgHamburger;
  }
} 